import { Record } from 'immutable';

export default class InvoiceRecord extends Record({
  id: undefined,
  amounts: undefined,
  createdAt: undefined,
  createdBy: undefined,
  customer: undefined,
  customerAgreement: undefined,
  details: undefined,
  dueAt: undefined,
  globalLocationNumber: undefined,
  invoiceDate: undefined,
  invoiceDeliveryType: undefined,
  invoiceNumber: undefined,
  links: undefined,
  organisationNumber: undefined,
  paidAt: undefined,
  paymentTerms: undefined,
  recipient: undefined,
  sender: undefined,
  sentAt: undefined,
  settings: undefined,
  staffingCompany: undefined,
  timeplanUnits: undefined,
  total: undefined,
}) {
}
